import {
  TableBody,
  TableCell,
  TableRow,
  Table,
  TableHeader,
  TableHeaderCell,
  TableCellLayout,
  Select,
  Checkbox,
  Button,
  makeStyles,
  shorthands,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogContent,
  DialogTrigger,
  Spinner,
  Option,
  Dialog,
  DialogSurface,
} from "@fluentui/react-components";
import React, { useEffect, useState } from "react";
import apiServices from "../service";
import { size } from "lodash";
import ASCButton from "./Button";
const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "75vh", // Adjust as needed
    width: "100%",
    backgroundColor: "#fff",
  },
  header: {
    padding: "16px",
    fontSize: "20px",
    fontWeight: "bold",
    borderBottom: "1px solid #ddd",
    backgroundColor: "#f4f4f4",
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  content: {
    flex: "1",
    overflowY: "auto",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },

  headerCell: {
    backgroundColor: "#2a5283",
    color: "white",
    fontWeight: "bold",
    textAlign: "left",
    padding: "6px",
    overflowWrap: "break-word",
    wordBreak: "break-word",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
  },
  bodyCell: {
    textAlign: "left",
    padding: "4px",
    overflowWrap: "break-word",
    wordBreak: "break-word",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
  },
  noDataCell: {
    textAlign: "center",
  },
});
const ModalDataHandler = (props: any) => {
  const classes = useStyles();
  const [columns, setColumns] = useState<{ [key: string]: any }[]>([]);
  const [dataList, setDataList] = useState<{ [key: string]: any }[]>([]);
  const [checkedItems, setCheckedItems] = useState<any>([]);
  const [isContentLoading, setIsContentLoading] = useState(true);
  const [apiProcessing, setApiProcessing] = useState(false);
  const [ratingList, setRatingList] = useState<{ [key: string]: any }[]>([]);
  const [selectValues, setSelectValues] = useState<any[]>([]);
  const [checkedRowItems, setCheckedRowItems] = useState<any>([]);
  const columnDefinitions: any = {
    attitudeToRisk: [
      { columnKey: "check", label: "" },
      { columnKey: "category", label: "Category" },
      { columnKey: "rating", label: "Rating" },
    ],
    income_categories: [
      { columnKey: "check", label: "" },
      { columnKey: "sort_order", label: "Sortorder" },
      { columnKey: "description", label: "Description" },
      { columnKey: "frequency", label: "Frequency" },
    ],
    outgoings: [
      { columnKey: "check", label: "" },
      { columnKey: "sort_order", label: "Sortorder" },
      { columnKey: "description", label: "Description" },
      { columnKey: "discretionary", label: "Type" },
      { columnKey: "frequency", label: "Frequency" },
    ],
    objectives: [
      { columnKey: "check", label: "" },
      { columnKey: "sort_order", label: "Sortorder" },
      { columnKey: "detail", label: "Detail" },
    ],
  };

  useEffect(() => {
    if (props.activeModalDataItem !== "") {
      setColumns(columnDefinitions[props.activeModalDataItem] || []);
      fetchDataList();
    }
  }, [props.activeModalDataItem, ratingList, checkedRowItems, checkedItems]);

  const formatData = async (data: any, category: string) => {
    let mappedArray = [];
    if (category === "income_categories") {
      mappedArray = data.map((data: any, index: number) => ({
        sort_order: data.sort_order,
        description: data.description,
        frequency: data.frequency,
        checkBox: (
          <Checkbox
            value={Object.values({
              income_category_id: data.id,
            })}
            checked={checkedRowItems.includes(data.id)}
            onChange={() => handleCheckboxIncome(data.id)}
            disabled={
              checkedItems.length >= 10 && !checkedRowItems.includes(data.id)
            }
          />
        ),
      }));
    } else if (category === "outgoings") {
      mappedArray = data.map((data: any, index: number) => {
        return {
          sort_order: data.sort_order,
          description: data.description,
          frequency: data.frequency,
          discretionary: data.discretionary,
          checkBox: (
            <Checkbox
              value={Object.values({
                expense_category_id: data.id,
              })}
              checked={checkedRowItems.includes(data.id)}
              onChange={() => handleCheckboxExpense(data.id)}
              disabled={
                checkedItems.length >= 10 && !checkedRowItems.includes(data.id)
              }
            />
          ),
        };
      });
    } else if (category === "objectives") {
      mappedArray = data.map((data: any, index: number) => {
        return {
          sort_order: data.sort_order,
          detail: data.detail,
          checkBox: (
            <Checkbox
              value={Object.values({
                detail_id: data.id,
              })}
              checked={checkedRowItems.includes(data.id)}
              onChange={() => handleCheckbox(data.id)}
              disabled={
                checkedItems.length >= 10 && !checkedRowItems.includes(data.id)
              }
            />
          ),
        };
      });
    } else if (category === "attitudeToRisk") {
      mappedArray = data.map((data: any, index: number) => {
        return {
          category: data.category,
          rating: (
            <select
              value={selectValues[index] || ""}
              onChange={(e) => onRatingChange(data, index, e.target.value)}
              disabled={!checkedRowItems.includes(data.id)} // ✅ KEY LINE
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "200px",
                backgroundColor: checkedRowItems.includes(data.id)
                  ? "#fff"
                  : "#f5f5f5",
                cursor: checkedRowItems.includes(data.id)
                  ? "pointer"
                  : "not-allowed",
              }}
            >
              <option value="">Select Rating</option>
              {ratingList.map((option: any) => (
                <option key={option.id} value={option.id}>
                  {option.rating}
                </option>
              ))}
            </select>
          ),

          checkBox: (
            <Checkbox
              value={data.id}
              checked={checkedRowItems.includes(data.id)}
              onChange={() => handleCheckboxChange(data.id)}
              disabled={
                checkedRowItems.length >= 10 &&
                !checkedRowItems.includes(data.id)
              }
            />
          ),
        };
      });
    }

    return mappedArray;
  };
  const onRatingChange = (data: any, index: number, value: string) => {
    if (!checkedRowItems.includes(data.id)) return; // ✅ safety

    setSelectValues((prev) => {
      const updated = [...prev];
      updated[index] = value;
      return updated;
    });

    setCheckedItems((prev: any[]) => {
      const filtered = prev.filter((item) => item.category_id !== data.id);

      return value
        ? [...filtered, { category_id: data.id, rating_id: value }]
        : filtered;
    });
  };

  const handleCheckboxChange = (dataId: number) => {
    setCheckedRowItems((prev: number[]) => {
      const isChecked = prev.includes(dataId);
      return isChecked ? prev.filter((id) => id !== dataId) : [...prev, dataId];
    });

    setCheckedItems((prev: any[]) => {
      const exists = prev.some((item) => item.category_id === dataId);

      if (exists) {
        // Remove it
        return prev.filter((item) => item.category_id !== dataId);
      }

      // Add it
      return [...prev, { category_id: dataId, rating_id: "" }];
    });
  };

  const handleCheckbox = (dataId: any) => {
    setCheckedItems((prev: []) => {
      const isChecked = prev.some((item: any) => item.detail_id === dataId);

      const updatedCheckedItems = isChecked
        ? prev.filter((item: any) => !(item.detail_id === dataId))
        : [...prev, { detail_id: dataId }];

      setCheckedRowItems((prevRows: any[]) => {
        const hasCheckedItems = updatedCheckedItems.some(
          (item) => item.detail_id === dataId,
        );

        if (hasCheckedItems) {
          return prevRows.includes(dataId) ? prevRows : [...prevRows, dataId];
        } else {
          return prevRows.filter((id) => id !== dataId);
        }
      });

      return updatedCheckedItems;
    });
  };
  const handleCheckboxExpense = (dataId: any) => {
    setCheckedItems((prev: []) => {
      const isChecked = prev.some(
        (item: any) => item.expense_category_id === dataId,
      );

      const updatedCheckedItems = isChecked
        ? prev.filter((item: any) => !(item.expense_category_id === dataId))
        : [...prev, { expense_category_id: dataId }];

      setCheckedRowItems((prevRows: any[]) => {
        const hasCheckedItems = updatedCheckedItems.some(
          (item) => item.expense_category_id === dataId,
        );

        if (hasCheckedItems) {
          return prevRows.includes(dataId) ? prevRows : [...prevRows, dataId];
        } else {
          return prevRows.filter((id) => id !== dataId);
        }
      });

      return updatedCheckedItems;
    });
  };
  const handleCheckboxIncome = (dataId: any) => {
    setCheckedItems((prev: []) => {
      const isChecked = prev.some(
        (item: any) => item.income_category_id === dataId,
      );

      const updatedCheckedItems = isChecked
        ? prev.filter((item: any) => !(item.income_category_id === dataId))
        : [...prev, { income_category_id: dataId }];

      setCheckedRowItems((prevRows: any[]) => {
        const hasCheckedItems = updatedCheckedItems.some(
          (item) => item.income_category_id === dataId,
        );

        if (hasCheckedItems) {
          return prevRows.includes(dataId) ? prevRows : [...prevRows, dataId];
        } else {
          return prevRows.filter((id) => id !== dataId);
        }
      });

      return updatedCheckedItems;
    });
  };

  const fetchDataList = async () => {
    if (props.activeModalDataItem === "income_categories") {
      try {
        const response =
          await apiServices.systemManager.incomeCategory.getList();
        if (!response.data.isError && response.data.data) {
          const result = await formatData(
            response.data.data,
            props.activeModalDataItem,
          );

          setDataList(result);
          setIsContentLoading(false);
        }
      } catch (err) {
        setIsContentLoading(false);
        console.error(err);
      }
    } else if (props.activeModalDataItem === "outgoings") {
      try {
        const response =
          await apiServices.systemManager.expenseCategory.getList();
        if (!response.data.isError && response.data.data) {
          const result = await formatData(
            response.data.data,
            props.activeModalDataItem,
          );

          setDataList(result);
          setIsContentLoading(false);
        }
      } catch (err) {
        setIsContentLoading(false);
        console.error(err);
      }
    } else if (props.activeModalDataItem === "objectives") {
      try {
        const response = await apiServices.systemManager.objectives.getList();
        if (!response.data.isError && response.data.data) {
          const result = await formatData(
            response.data.data,
            props.activeModalDataItem,
          );

          setDataList(result);
          setIsContentLoading(false);
        }
      } catch (err) {
        setIsContentLoading(false);
        console.error(err);
      }
    } else if (props.activeModalDataItem === "attitudeToRisk") {
      try {
        const [attitudeRatingResponse, attitudeRiskCategoryResponse] =
          await Promise.all([
            apiServices.systemManager.attitudeToRiskRating.getList(),
            apiServices.systemManager.attitudeToRiskcategory.getList(),
          ]);

        if (
          !attitudeRatingResponse.data.isError &&
          attitudeRatingResponse.data.data
        ) {
          setRatingList(attitudeRatingResponse.data.data);
        }
        if (
          !attitudeRiskCategoryResponse.data.isError &&
          attitudeRiskCategoryResponse.data.data
        ) {
          const formattedRiskData = await formatData(
            attitudeRiskCategoryResponse.data.data,
            "attitudeToRisk",
          );
          setDataList(formattedRiskData);
        }
        setIsContentLoading(false);
      } catch (err) {
        setIsContentLoading(false);
        console.error(err);
      }
    } else {
      setIsContentLoading(false);
    }
  };

  const tableBody = () => {
    if (dataList.length > 0) {
      if (props.activeModalDataItem === "attitudeToRisk") {
        return dataList.map((items: any, index: number) => (
          <TableRow as="tr" key={`${items.category}-${index}`}>
            <TableCell
              as="td"
              style={{
                width: "60px",
                padding: "4px",
              }}
            >
              {items.checkBox}
            </TableCell>
            <TableCell as="td">{items.category}</TableCell>
            <TableCell as="td">{items.rating}</TableCell>
          </TableRow>
        ));
      } else if (props.activeModalDataItem === "income_categories") {
        return dataList.map((items: any) => (
          <TableRow key={items.id}>
            <TableCell
              as="td"
              style={{
                width: "60px",
                padding: "4px",
              }}
            >
              {items.checkBox}
            </TableCell>
            <TableCell as="td">{items.sort_order}</TableCell>
            <TableCell as="td">{items.description}</TableCell>

            <TableCell as="td">{items.frequency}</TableCell>
          </TableRow>
        ));
      } else if (props.activeModalDataItem === "outgoings") {
        return dataList.map((items: any) => (
          <TableRow key={items.id}>
            <TableCell
              as="td"
              style={{
                width: "60px",
                padding: "4px",
              }}
            >
              {items.checkBox}
            </TableCell>

            <TableCell as="td">{items.sort_order}</TableCell>
            <TableCell as="td">{items.description}</TableCell>

            <TableCell as="td">{items.discretionary}</TableCell>

            <TableCell as="td">{items.frequency}</TableCell>
          </TableRow>
        ));
      } else if (props.activeModalDataItem === "objectives") {
        return dataList.map((items: any) => (
          <TableRow key={items.id}>
            <TableCell
              as="td"
              style={{
                width: "60px",
                padding: "4px",
              }}
            >
              {items.checkBox}
            </TableCell>
            <TableCell as="td">{items.sort_order}</TableCell>
            <TableCell as="td">{items.detail}</TableCell>
          </TableRow>
        ));
      } else
        return (
          <TableRow>
            <TableCell colSpan={columns.length} align="center">
              <p className={classes.noDataCell}>No data found</p>
            </TableCell>
          </TableRow>
        );
    } else {
      return (
        <TableRow>
          <TableCell colSpan={columns.length} align="center">
            <p className={classes.noDataCell}>No data found</p>
          </TableCell>
        </TableRow>
      );
    }
  };

  const handleApply = () => {
    if (checkedItems.length > 0) {
      setApiProcessing(true);
      if (props.activeModalDataItem === "income_categories") {
        let reqBody = {
          income: {
            customer_id: props.clientId,
            income_categories: checkedItems,
          },
        };
        apiServices.getDefaultIncome
          .add(reqBody)
          .then((response: any) => {
            handleApiSuccessResponse(response);
          })
          .catch((e: Error) => {
            console.log(e);
            props.notify(e.message, "", "error");
            setApiProcessing(false);
          });
      } else if (props.activeModalDataItem === "outgoings") {
        let reqBody = {
          outgoings: {
            customer_id: props.clientId,
            expense_categories: checkedItems,
          },
        };
        apiServices.getDefaultexpense
          .add(reqBody)
          .then((response: any) => {
            handleApiSuccessResponse(response);
          })
          .catch((e: Error) => {
            console.log(e);
            props.notify(e.message, "", "error");
            setApiProcessing(false);
          });
      } else if (props.activeModalDataItem === "objectives") {
        let reqBody = {
          Objective: {
            customer_id: props.clientId,
            objectives: checkedItems,
          },
        };
        apiServices.getDefaultobjective
          .add(reqBody)
          .then((response: any) => {
            handleApiSuccessResponse(response);
          })
          .catch((e: Error) => {
            console.log(e);
            props.notify(e.message, "", "error");
            setApiProcessing(false);
          });
      } else if (props.activeModalDataItem === "attitudeToRisk") {
        let reqBody = {
          attitude_to_risk: {
            customer_id: props.clientId,
            attitude_risks: checkedItems,
          },
        };
        // let hasEmptyRating = checkedItems.some(
        //   (item: any) => item.rating_id === "" || item.rating_id === undefined
        // );

        // if (hasEmptyRating) {
        //   props.notify(
        //     "One or more 'rating' values are empty. Please fill rating.",
        //     "",
        //     "error"
        //   );
        //   setApiProcessing(false);
        // } else {
        apiServices.getDefaultAttitudeToRisk
          .add(reqBody)
          .then((response: any) => {
            handleApiSuccessResponse(response);
          })
          .catch((e: Error) => {
            console.log(e);
            props.notify(e.message, "", "error");
            setApiProcessing(false);
          });
      }
      // }
    } else {
      props.notify("One or more items are required", "", "error");
    }
  };
  const handleApiSuccessResponse = (response: any) => {
    setApiProcessing(false);

    const { data } = response;

    if (!data.isError) {
      setTimeout(() => {
        setCheckedItems([]);
        props.reloadItemList();
        props.setLoadMasterData(false);
      }, 1000);
      props.notify(data.message, "", "success");
    } else if (data.isError && data.error && Object.keys(data.error).length) {
      const errorMessage = Array.isArray(data.error.message)
        ? data.error.message.join(", ")
        : data.error.message;
      props.notify(errorMessage, "", "error");
    } else {
      props.notify("Something went wrong", "", "error");
    }
  };

  return (
    <Dialog open={props.loadMasterData} modalType="non-modal">
      <DialogSurface aria-modal="false">
        <DialogBody>
          <DialogContent>
            <div className={classes.container}>
              <div className={classes.content}>
                {isContentLoading ? (
                  <div className={classes.loaderContainer}>
                    <Spinner label="Loading..." labelPosition="below" />
                  </div>
                ) : (
                  <>
                    {columns.length > 0 && (
                      <Table className={classes.table} as="table">
                        <TableHeader as="thead">
                          <TableRow as="tr">
                            {columns.map((column) => (
                              <TableHeaderCell
                                as="th"
                                key={column.columnKey}
                                className={classes.headerCell}
                                style={{
                                  width:
                                    column.columnKey === "check"
                                      ? "60px"
                                      : "auto",
                                  textAlign:
                                    column.columnKey === "check"
                                      ? "center"
                                      : "left",
                                  padding:
                                    column.columnKey === "check"
                                      ? "4px"
                                      : "6px",
                                }}
                              >
                                {column.label}
                              </TableHeaderCell>
                            ))}
                          </TableRow>
                        </TableHeader>
                        <TableBody as="tbody" className={classes.bodyCell}>
                          {tableBody()}
                        </TableBody>
                      </Table>
                    )}
                  </>
                )}
              </div>
            </div>
          </DialogContent>
          {!isContentLoading && (
            <DialogActions>
              <ASCButton
                shape="rounded"
                className="asc-button-primary"
                appearance="primary"
                size="medium"
                icon={apiProcessing ? <Spinner size="tiny" /> : null}
                disabled={checkedRowItems.length > 0 ? false : true}
                onClick={() => {
                  handleApply();
                }}
                label={apiProcessing ? "Processing..." : "Apply"}
              />
              <ASCButton
                shape="rounded"
                appearance="secondary"
                size="medium"
                onClick={() => {
                  props.setLoadMasterData(false);
                }}
                label="Close"
              />
            </DialogActions>
          )}
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
export default ModalDataHandler;
